import type { PayrollPeriod } from '../core/types';

interface Props {
  periods: PayrollPeriod[];
  selected: string;
  setSelected: (value: string) => void;
}

export function MonthSelector({ periods, selected, setSelected }: Props) {
  return (
    <section className="card compact-card">
      <h2>2. Competência</h2>
      {periods.length === 0 ? (
        <p className="muted">Analise os arquivos para detectar as competências disponíveis.</p>
      ) : (
        <>
          <select value={selected} onChange={(event) => setSelected(event.target.value)}>
            {periods.map((period) => (
              <option key={period.label} value={period.label}>
                {period.label} — {period.displayRange}
              </option>
            ))}
          </select>
          <p className="muted">Regra atual: dia 25 até dia 26 do mês seguinte.</p>
        </>
      )}
    </section>
  );
}
